import React from 'react'

export default function Loading({loading}) {
  return (
    <div className="center">
      <div className="loader-sonar">
        <span />
        <span />
      </div>
    </div>
  )
}
